/* eslint-disable import/prefer-default-export */
import { atom } from 'recoil';
import { JSObject } from '../../types.d';

export const UiUserContext = atom<JSObject>({
  key: 'ui-user-context-atom',
  default: {},
});
